import React from "react";
import {
    StyleSheet,
    Text,
    View,
    ImageBackground,
    ScrollView,
    TouchableOpacity,
    TextInput,
    Alert,
    // ToastAndroid
} from 'react-native';
import Config from "../components/Config";

import {RFValue} from "react-native-responsive-fontsize";

import { Ionicons } from '@expo/vector-icons';
import T from "./Tab/t";
import {useFocusEffect} from "@react-navigation/native";
import AsyncStorage from "@react-native-async-storage/async-storage";
import axios from "axios";
// import Toast from "react-native-tiny-toast";
import ToastNotification from 'react-native-toast-notification'


const Withdraw = ({navigation})=>{

    useFocusEffect(
        React.useCallback(() => {
            getData();
        }, [])
    );


    let [amount,setAmount] = React.useState('0');
    let [toast,setToast] = React.useState(false);


    let [profile,setProfile] = React.useState({
        withdrawbleAmount : '0',
        wallet_address : 'Loading ... '

    });

    const getData = async ()=>{
        let token = await AsyncStorage.getItem('token');



        let res = await axios.get(
            `${Config.base}/api/v1/profile`,
            { params:
                    {
                        token: token
                    }
            }
        );
        profile = res.data;
        setProfile(res.data);

        // console.log(res.data.withdrawbleAmount2);



        const resultnumber = res.data.withdrawbleAmount.replace(/\D/g, '');
        //
        let amount2 = res.data.withdrawbleAmount2.toString();
        setAmount(amount2);
    };

    const send = async ()=>{
        let token = await AsyncStorage.getItem('token');
        let formData = new FormData();
        formData.append('send_price', amount);
        formData.append('token', token);

        // Toast.showLoading('Sending Data ...');
        setToast('Sending Data ...');



        let res = await axios.post(
            `${Config.base}/api/v1/withdrawProfite`,
            formData,
            {
                headers: {
                    "Content-Type": "multipart/form-data",
                }
            }
        );


        // Toast.hide('');
        if(res.data.status == 200){

            // Toast.showSuccess(res.data.message);
           navigation.navigate('Wallet');
        }else{
            // Alert.alert('Error', res.data.message, [
            //     {
            //         text: 'Close',
            //         onPress: () => {
            //         },
            //         style: 'default',
            //     },
            // ]);
            // Toast.show(res.data.message);

            // ToastAndroid.show('X '+res.data.message, ToastAndroid.SHORT);

            setToast(res.data.message);

            const timeoutId = setTimeout(() => {
                setToast(false);
            }, 3000);
        }
    }




    return (
        <View style={{flex : 1}}>
            <ImageBackground
                source={{uri: 'https://metamax.network/public/appBg.jpg'}}
                // source={{uri: 'https://img.freepik.com/free-photo/minimalistic-still-life-arrangement-with-cryptocurrency_23-2149102090.jpg?w=740&t=st=1694093218~exp=1694093818~hmac=d9334eec05ae93b0588ef7cd2b5b01df82be982db4bb333380c6e5760732c18e'}}
                resizeMode="cover" style={{flex : 1}}>
                <View style={styles.headercon}>
                    <TouchableOpacity style={{backgroundColor : 'transparent'}} onPress={()=>navigation.goBack()}>
                        <Ionicons   name="return-up-back" size={RFValue(35)} color="#FFF" />
                    </TouchableOpacity>
                    <Text style={styles.header}>
                        Withdraw
                    </Text>
                </View>



              <View style={{flex : 1,justifyContent : 'flex-start'}}>
                  <View style={styles.box2}>

                      <View>
                          <Text style={styles.label}>
                              Address :
                          </Text>
                          <View style={{flexDirection : 'row'}}>
                              <TextInput editable={false} value={profile.wallet_address} placeholder={'Enter Address'} style={styles.textinput}/>
                          </View>

                      </View>
                      <View>
                          <Text style={styles.label}>
                              Amount :
                          </Text>
                          <View >
                              <Text style={styles.spanStyle}>$</Text>
                              <TextInput   value={amount} keyboardType={"numeric"} onChangeText={setAmount} placeholder={'USDT'} style={styles.textinput}/>
                          </View>

                          <Text style={styles.textfee}>
                             Network FEE : 1 USDT
                          </Text>
                          <Text style={styles.textfee}>
                              MaxInvest FEE : 4%
                          </Text>

                          <Text style={styles.recivetext}>
                              Recive Price : 350 USDT
                          </Text>


                          <TouchableOpacity onPress={send} style={{justifyContent : 'center',alignItems : 'center',marginTop : RFValue(25)}}>
                              <View style={styles.btn2}>
                                  <Text  style={styles.btntext}>Send</Text>
                              </View>
                          </TouchableOpacity>

                          {toast.length &&
                              <ToastNotification
                                  // textStyle={{ color: 'red' }}
                                  // style={{ backgroundColor: 'yellow' }}
                                  text={toast}
                                  // duration={99999999999}
                                  isTop={true}
                                  style={{ padding: RFValue(10), minHeight: 100 }}
                              />
                          }


                      </View>

                  </View>
              </View>

            </ImageBackground>




        </View>
    );
}


const styles = StyleSheet.create({
    spanStyle : {
      position : 'absolute',
      right : RFValue(10),
      top : RFValue(5),
      color : '#FFF',
        fontSize : RFValue(25)
    },
    recivetext : {
        fontFamily : 'novaria',
        color : '#f6f6f6',
        textAlign : 'center',
        fontSize : RFValue(14),
        display : 'none' ,
        paddingVertical : RFValue(5)
    },

    textfee:{
        fontFamily : 'novaria',
        color : '#e1e1e1',
        // textAlign : 'center',
        fontSize : RFValue(12),
        paddingTop : RFValue(5),
    },

    label:{
        fontFamily : 'novaria',
        color : '#f6f6f6',
        // textAlign : 'center',
        fontSize : RFValue(16),
        paddingVertical : RFValue(10)
    },
    textinput : {
        fontSize : RFValue(16),
        paddingVertical : RFValue(10),
        paddingHorizontal : RFValue(10),
        borderWidth : 1,
        color : '#e1e1e1',
        borderColor : '#f6f6f6',
        width : '99%',
        borderRadius : RFValue(4)

    },


    btn2 : {

        borderWidth : 1,
        borderColor : 'transparent',
        width : '30%',
        margin : "auto",
        justifyContent : "center",
        alignItems: 'center',
        padding : RFValue(5),
        borderRadius : RFValue(5),
        backgroundColor : '#009688'
    },

    btn : {

        borderWidth : 1,
        borderColor : '#FFF',
        width : RFValue(120),
        justifyContent : "center",
        alignItems: 'center',
        padding : RFValue(3),
        borderRadius : RFValue(5),
        backgroundColor : 'transparent',
        marginHorizontal : RFValue(5)
    },

    btntext : {
        color : '#FFF',
        fontFamily : 'novaria',
    },



    box2 : {
        margin : RFValue(12),
        backgroundColor : 'transparent',
        padding:RFValue(10),
        borderRadius : RFValue(10),
        // flex : 1,
        // flexDirection : 'row',
    },


    headercon : {
        backgroundColor : 'transparent',
        flexDirection : 'row',
        alignItems : "center",
        paddingVertical : RFValue(3),
        paddingHorizontal : RFValue(25),
        // borderTopWidth : 1,
        // borderTopColor : '#FFF',

        borderBottomWidth : 1,
        borderBottomColor : '#f6f6f6',

    },
    header : {
        fontFamily : 'novaria',
        color : '#FFF',
        textAlign : 'center',
        fontSize : RFValue(20),
        padding : RFValue(20),

        textShadowColor: 'rgba(0, 0, 0, 0.75)',
        textShadowOffset: {width: -1, height: 1},
        textShadowRadius: 3,
        flex : 1,
        marginRight : RFValue(20)


    },



});


export default Withdraw;
